import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';
import { reduxForm } from 'redux-form';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { FormControlLabel } from 'material-ui/Form';
import { Switch } from 'material-ui';
import { ModalTemplate, Loading, Button as Btn, ReduxFormMaterialTextField, ReduxFormMaterialSwitch } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ExamTemplateReceiveTest.css';
const cx = classNames.bind(styles);

class ExamTemplateReceiveTest extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { getSmtpStatus } = this.props;

    getSmtpStatus();
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth, user, progressing, testTemplateReceived, handleOnToggleReceiveTestModal } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleReceiveTestModal}
        visible
        header={
          <div>
            {defineMessages(
              formatMessage({ id: 'ExamTemplateReceiveTest_1', defaultMessage: '훈련 양식(템플릿) 수신 테스트' })
            )}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleReceiveTestModal}>
              {defineMessages(formatMessage({ id: 'ExamTemplateReceiveTest_2', defaultMessage: '취 소' }))}
            </Btn>
            <Btn
              className={cx('brand-button')}
              loading={progressing}
              disabled={progressing}
              onClick={testTemplateReceived}>
              {defineMessages(formatMessage({ id: 'ExamTemplateReceiveTest_3', defaultMessage: '실 행' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={progressing}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateReceiveTest_4', defaultMessage: '테스트 중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateReceiveTest_5',
              defaultMessage: '훈련 템플릿을 본인 환경의 이메일로 발송하여'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateReceiveTest_8',
              defaultMessage: '정상 수신 여부를 확인합니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateReceiveTest_10',
              defaultMessage: '(피싱 템플릿은 단순 메일만 확인 가능)'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            {/* <div className={cx('template-detail-name')}>세부정보</div> */}
            {/* <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateReceiveTest_6', defaultMessage: '수신자' }))}
                </div>
                {user.userEmail}
              </List.Item>
            </List> */}
            <List className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <ReduxFormMaterialSwitch
                  className={cx('input-switch')}
                  label={defineMessages(
                    formatMessage({
                      id: 'ExamTemplateReceiveTest_7',
                      defaultMessage: '기존에 수신 성공한 템플릿도 다시 발송'
                    })
                  )}
                  name="forceTest"
                  checkType={101}
                />
              </List.Item>
            </List>
            <div className={cx('inputName-title')}>
              {defineMessages(formatMessage({ id: 'ExamTemplateReceiveTest_9', defaultMessage: '발송 이메일' }))}
            </div>
            <List className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <ReduxFormMaterialTextField
                  fullWidth
                  // label={defineMessages(formatMessage({ id: 'ExamTemplateEdit_12', defaultMessage: '발송 이메일' }))}
                  name="senderEmail"
                  className={cx('input-area', 'input-flex')}
                  checkType={101}
                  validate={['required', 'email']}
                />
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

export default reduxForm({
  form: 'testTemplateReceived',
  enableReinitialize: true,
  touchOnChange: true
})(injectIntl(ExamTemplateReceiveTest));



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateReceiveTest.js